import script from "./ChatPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPanel.vue?vue&type=script&setup=true&lang=js"

import "./ChatPanel.vue?vue&type=style&index=0&id=3b8d4e96&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b8d4e96"]])

export default __exports__